export enum FileTypeEnum {
  VINData = 1,
  Duplicates = 2
}

export const FileTypeEnumDescriptions: { [key in FileTypeEnum]: string } = {
  [FileTypeEnum.VINData]: "VINData",
  [FileTypeEnum.Duplicates]: "Duplicates"
};

export enum ExtensionEnum {
  PDF = 1,
  XLS = 2,
  XLSX = 3,
  DOC = 4,
  DOCX = 5,
  MDB = 6
}

export const ExtensionEnumDescriptions: { [key in ExtensionEnum]: string } = {
  [ExtensionEnum.PDF]: "pdf",
  [ExtensionEnum.XLS]: "xls",
  [ExtensionEnum.XLSX]: "xlsx",
  [ExtensionEnum.DOC]: "doc",
  [ExtensionEnum.DOCX]: "docx",
  [ExtensionEnum.MDB]: "mdb"
};

export enum FileStatusEnum {
  Pending = 1,
  Processing = 2,
  Completed = 3,
  CompletedWithErrors = 4
}

export const FileStatusEnumDescriptions: { [key in FileStatusEnum]: string } = {
  [FileStatusEnum.Pending]: "Pending",
  [FileStatusEnum.Processing]: "Processing",
  [FileStatusEnum.Completed]: "Completed",
  [FileStatusEnum.CompletedWithErrors]: "CompletedWithErrors"
};

export enum ValuationServiceEnum {
  JDPowerApps = 1,
  STL = 2,
  PriceDigest = 3
}

export const ValuationServiceEnumDescriptions: { [key in ValuationServiceEnum]: string } = {
  [ValuationServiceEnum.JDPowerApps]: "JD Power Apps",
  [ValuationServiceEnum.STL]: "STL",
  [ValuationServiceEnum.PriceDigest]: "Price Digest"
};


export const InternalProductEnum = {
  InternalAnnualProcedures: 1,
  InternalSolutions: 2,
}

export enum PublicProductEnum {
  cappsportal = 1,
  adminportal = 2,
  collectorsaccounting = 3,
  countyadminportal = 4,
  homesteaddetailsportal = 5
}

export const ckEditorConfiguration = {
  placeholder: '',
  height: '1000',
  width: '100%',
  toolbar: {
      items: [
          /*'undo', 'redo',
          '|', 'heading', 'selectAll','insertTable',
          '|', 'bold', 'italic',
          '|', 'link', 'blockQuote','uploadImage','mediaEmbed',
          '|', 'bulletedList', 'numberedList', 'outdent', 'indent',*/
          'findAndReplace', 'selectAll', '|',
          'heading', '|',
          'bold', 'italic', 'strikethrough', 'underline', 'removeFormat', '|',
          'bulletedList', 'numberedList', '|',
          'outdent', 'indent', '|',
          'undo', 'redo',
          '-',
          'fontSize', 'fontFamily', 'fontColor', 'fontBackgroundColor', 'highlight', 'subscript', 'superscript', '|',
          'alignment', '|',
          'link', 'insertImage', 'blockQuote', 'insertTable', 'mediaEmbed', '|',
          'specialCharacters', 'horizontalLine', 'pageBreak', '|',
          'sourceEditing'
      ], //'htmlEmbed',
      table: {
          contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
      },
      shouldNotGroupWhenFull: true,
      allowedContent: true,
  },
  htmlEmbed: {
      showPreviews: true
  },
  htmlSupport: {
      allow: [
          {
              name: /.*/,
              attributes: true,
              classes: true,
              styles: true
          }
      ]
  },
  mediaEmbed: {
      removeProviders: ['instagram', 'twitter', 'googleMaps', 'flickr', 'facebook', 'spotify', 'vimeo', 'dailymotion']
  },
  ckfinder: {
      options: {
          resourceType: 'Images'
      },
  },
  removePlugins: [
      // These two are commercial, but you can try them out without registering to a trial.
      'ExportPdf',
      'ExportWord',
      'CKBox',
      'CKFinder',
      'EasyImage',
      // This sample uses the Base64UploadAdapter to handle image uploads as it requires no configuration.
      // https://ckeditor.com/docs/ckeditor5/latest/features/images/image-upload/base64-upload-adapter.html
      // Storing images as Base64 is usually a very bad idea.
      // Replace it on production website with other solutions:
      // https://ckeditor.com/docs/ckeditor5/latest/features/images/image-upload/image-upload.html
      // 'Base64UploadAdapter',
      'RealTimeCollaborativeComments',
      'RealTimeCollaborativeTrackChanges',
      'RealTimeCollaborativeRevisionHistory',
      'PresenceList',
      'Comments',
      'TrackChanges',
      'TrackChangesData',
      'RevisionHistory',
      'Pagination',
      'WProofreader',
      // Careful, with the Mathtype plugin CKEditor will not load when loading this sample
      // from a local file system (file://) - load this site via HTTP server if you enable MathType.
      'MathType',
      // The following features are part of the Productivity Pack and require additional license.
      'SlashCommand',
      'Template',
      'DocumentOutline',
      'FormatPainter',
      'TableOfContents',
      'PasteFromOfficeEnhanced',
      //'Base64UploadAdapter',
      'AutoImage',
      'Markdown',
      'MediaEmbedToolbar',
      'Title'
  ]
}

export const validationConst = {
  nameMaxLength: 50,
  countyAdminPortalNameMaxLength: 100,
  countyAdminPortalEntityNameMaxLength: 200,
  countyAdminPortalEntityDescriptionMaxLength: 2000,
  userRemarksMaxLength: 500,
};

export const PortalTypeConst = {
  CAPPS: 1,
  Individual: 2,
  Business: 3,
  Fleet: 4
}

export const AccountTypeConst = {
  COUNTIES: 1
}

export enum HomeSteadEntityApplicationStatusEnum {
  Pending = 1,
  Complete = 2,
  Incomplete,
  Qualified,
  Disqualified,
  ValuesEntered,
  ValuesCorrection,
  ValuesVerified,
  CreditsTransferred,
  CreditsCalculated,
  CreditsUsed
}

export enum HomeSteadCreditPageEnum {
  TaxPayers = 1,
  Applications,
  PageTitleInfo,
  Guidelines,
  FAQ,
  ApplicationHeader,
  ApplicationFooter,
  ApplicationDocuments,
  ApplicationCertification,
  CloseApplicationPeriod,
  ApplicationPeriods,
  NotificationSetup
}

export enum breadcrumbDropdownEnum {
  ProductType = 1,
  Page = 2,
}


export const FileStatusList = [
  {
    "id": 1,
    "name": "Pending",
    "enumValue": 1,
    "type": "Pending",
    "extraProperty": null,
    "isActive": false
  },
  {
    "id": 2,
    "name": "Processing",
    "enumValue": 2,
    "type": "Processing",
    "extraProperty": null,
    "isActive": false
  },
  {
    "id": 3,
    "name": "Completed",
    "enumValue": 3,
    "type": "Completed",
    "extraProperty": null,
    "isActive": false
  },
  {
    "id": 4,
    "name": "Completed With Errors",
    "enumValue": 4,
    "type": "Completed With Errors",
    "extraProperty": null,
    "isActive": false
  }
]

export enum ImportTemplateTypeEnum  {
  Parcel=1
}

export const DefaultTimeZoneEnum  = {
  CentralTime_US_Canada : 16
}

export enum AdminRoles {
  SuperAdmin = 1,
  AccountAdmin = 2,
  FinanceAdmin = 3,
  DataManager = 4 
}